import React, { Component, PropsWithChildren } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

export class CustomScrollbars extends Component<PropsWithChildren> {
  renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
      backgroundColor: "white",
      opacity: "0.4",
      borderRadius: "5px",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  render() {
    return (
      <Scrollbars renderThumbHorizontal={this.renderThumb} renderThumbVertical={this.renderThumb}>
        {this.props.children}
      </Scrollbars>
    );
  }
}
